import React, { ReactElement, useState } from "react";

import ContentLayout from "Components/ContentLayout";
import useDecodedParams from "Hooks/useDecodedParams";

import HttpMetrics from "./experiments/HttpMetrics";
import ResourcesByService from "./experiments/ResourcesByService";
import ResourcesOverview from "./experiments/ResourcesOverview";
import ServerCachesOverview from "./experiments/ServerCachesOverview/ServerCachesOverview";
import { Chevron, ExperimentHeader } from "./Page.styles";

type ExperimentProps = {
  title: string;
  experiment: () => ReactElement;
};

const Experiment = ({ title, experiment }: ExperimentProps) => {
  const [collapsed, setCollapsed] = useState<boolean>(true);

  return (
    <div>
      <ExperimentHeader
        onClick={() => {
          setCollapsed(!collapsed);
        }}
      >
        <Chevron color="currentColor" isOpen={!collapsed} />
        <h1>{title}</h1>
      </ExperimentHeader>
      {!collapsed && <div>{experiment()}</div>}
    </div>
  );
};

const Page = () => {
  const { environmentId, projectId } = useDecodedParams<{
    environmentId: string;
    projectId: string;
  }>();

  return (
    <ContentLayout>
      <p>
        Obs Sandbox is currently loaded for project {projectId}, environment{" "}
        {environmentId}
      </p>

      <Experiment
        title="Server caches overview"
        experiment={() => <ServerCachesOverview />}
      ></Experiment>

      <Experiment
        title="Resources Overview API (Last day)"
        experiment={() => <ResourcesOverview />}
      ></Experiment>

      <Experiment
        title="Resources By Service API (Last day)"
        experiment={() => <ResourcesByService />}
      ></Experiment>

      <Experiment
        title="HTTP Metrics API (Last day)"
        experiment={() => <HttpMetrics />}
      ></Experiment>
    </ContentLayout>
  );
};

export default Page;
